import React from 'react'
import { Link } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSelector } from 'react-redux'

export const CartBadge = () => {
    const { cartData } = useSelector(state => state.cart)
    return (
        <Link className='badge-icon' to="/reviewList">
            <Badge color="secondary" style={{ cursor: 'pointer', marginTop: '11px' }} badgeContent={cartData?.length}>
                <ShoppingCartIcon />{" "}
            </Badge>
        </Link>
    )
}
